<atom-modal-wrapper
    [modalId]="ENVELOPE_LOOKUP_MODAL_ID"
    [modalTemplate]="lookupModal"
>
    <ng-template #lookupModal>
        <organism-modal [modalTitle]="MODAL_TITLE">
            <molecule-info-card-search
                [mode]="MODE"
                [infoCards]="lookupCards$ | ngrxPush"
                [isLoading]="isLoading$ | ngrxPush"
                [hasError]="hasError$ | ngrxPush"
                (valueChanged)="onChange($event)"
                (confirm)="onConfirm()"
            ></molecule-info-card-search>
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
